import {
  ComponentBase_default,
  GetGame_default,
  GetSceneObject_default
} from "./chunk-2DCYBCRT.js";
import {
  AngleToDirections_default,
  Const_default,
  ScreenXYToWorldXY_default
} from "./chunk-WFQKEYPG.js";
import {
  EventEmitterMethods_default
} from "./chunk-D5JVWJXO.js";
import {
  init_shim
} from "./chunk-XJTZ422K.js";

// node_modules/phaser3-rex-plugins/plugins/gestures.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/gestures/tap/Tap.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/gestures/onepointertracer/OnePointerTracer.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/componentbase/TickTask.js
init_shim();
var GetValue = Phaser.Utils.Objects.GetValue;
var TickTask = class extends ComponentBase_default {
  constructor(parent, config) {
    super(parent, config);
    this._isRunning = false;
    this.isPaused = false;
    this.tickingState = false;
    this.setTickingMode(GetValue(config, "tickingMode", 1));
  }
  // override
  boot() {
    if (this.tickingMode === 2 && !this.tickingState) {
      this.startTicking();
    }
  }
  // override
  shutdown(fromScene) {
    if (this.isShutdown) {
      return;
    }
    this.stop();
    if (this.tickingState) {
      this.stopTicking();
    }
    super.shutdown(fromScene);
  }
  setTickingMode(mode) {
    if (typeof mode === "string") {
      mode = TICKINGMODE[mode];
    }
    this.tickingMode = mode;
  }
  // override
  startTicking() {
    this.tickingState = true;
  }
  // override
  stopTicking() {
    this.tickingState = false;
  }
  get isRunning() {
    return this._isRunning;
  }
  set isRunning(value) {
    if (this._isRunning === value) {
      return;
    }
    this._isRunning = value;
    if (this.tickingMode === 1 && value != this.tickingState) {
      if (value) {
        this.startTicking();
      } else {
        this.stopTicking();
      }
    }
  }
  start() {
    this.isPaused = false;
    this.isRunning = true;
    return this;
  }
  pause() {
    if (this.isRunning) {
      this.isPaused = true;
      this.isRunning = false;
    }
    return this;
  }
  resume() {
    if (this.isPaused) {
      this.isRunning = true;
    }
    return this;
  }
  stop() {
    this.isPaused = false;
    this.isRunning = false;
    return this;
  }
  complete() {
    this.isPaused = false;
    this.isRunning = false;
    this.emit("complete", this.parent, this);
  }
};
var TICKINGMODE = {
  "no": 0,
  "lazy": 1,
  "always": 2
};
var TickTask_default = TickTask;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/onepointertracer/OnePointerTracer.js
var GetValue2 = Phaser.Utils.Objects.GetValue;
var OnePointerTracer = class extends TickTask_default {
  constructor(gameObject, config) {
    var scene = GetSceneObject_default(gameObject);
    if (scene === gameObject) {
      gameObject = void 0;
    }
    super(scene, config);
    this.gameObject = gameObject;
    if (gameObject) {
      gameObject.setInteractive(GetValue2(config, "inputConfig", void 0));
    }
    this._enable = void 0;
    this.resetFromJSON(config);
    this.boot();
  }
  resetFromJSON(o) {
    this.setEnable(GetValue2(o, "enable", true));
    this.setDetectBounds();
    if (this.gameObject === void 0) {
      this.setDetectBounds(GetValue2(o, "bounds", void 0));
    } else {
      this.setDetectBounds();
    }
    this.tracerState = TOUCH0;
    this.pointer = void 0;
    this.lastPointer = void 0;
    this.movedState = false;
    this.isTouchingAnyObject = false;
    return this;
  }
  boot() {
    super.boot();
    if (this.gameObject) {
      this.gameObject.on("pointerdown", this.onPointerDown, this);
    } else {
      this.scene.input.on("pointerdown", this.onPointerDown, this);
    }
    this.scene.input.on("pointerup", this.onPointerUp, this);
    this.scene.input.on("gameout", this.dragCancel, this);
    this.scene.input.on("pointermove", this.onPointerMove, this);
    this.scene.sys.events.once("shutdown", this.destroy, this);
  }
  shutdown(fromScene) {
    if (!this.scene) {
      return;
    }
    if (this.gameObject) {
    } else {
      this.scene.input.off("pointerdown", this.onPointerDown, this);
    }
    this.scene.input.off("pointerup", this.onPointerUp, this);
    this.scene.input.off("gameout", this.dragCancel, this);
    this.scene.input.off("pointermove", this.onPointerMove, this);
    this.scene.sys.events.off("shutdown", this.destroy, this);
    this.gameObject = void 0;
    this.bounds = void 0;
    this.pointer = void 0;
    this.lastPointer = void 0;
    this.movedState = false;
    super.shutdown(fromScene);
  }
  get enable() {
    return this._enable;
  }
  set enable(e) {
    if (this._enable === e) {
      return;
    }
    if (!e) {
      this.dragCancel();
    }
    this._enable = e;
    return this;
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  setDetectBounds(bounds) {
    this.bounds = bounds;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  onPointerDown(pointer, gameObjects) {
    if (!this.enable) {
      return;
    }
    if (this.pointer !== void 0) {
      return;
    }
    var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
    if (!isInsideBounds) {
      return;
    }
    if (this.pointer === pointer) {
      return;
    }
    this.pointer = pointer;
    this.lastPointer = pointer;
    this.movedState = false;
    this.tracerState = TOUCH1;
    if (this.gameObject === void 0) {
      this.isTouchingAnyObject = gameObjects.length > 0;
    }
    this.onDragStart();
  }
  onPointerUp(pointer) {
    if (!this.enable) {
      return;
    }
    var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
    if (!isInsideBounds) {
      return;
    }
    if (this.pointer !== pointer) {
      return;
    }
    this.pointer = void 0;
    this.movedState = false;
    this.tracerState = TOUCH0;
    this.onDragEnd();
  }
  onPointerMove(pointer) {
    if (!this.enable) {
      return;
    }
    if (pointer.isDown) {
      var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
      var isCatchedPointer = this.pointer === pointer;
      if (!isCatchedPointer && isInsideBounds) {
      } else if (isCatchedPointer && !isInsideBounds) {
        this.onPointerUp(pointer);
      } else {
        if (!this.movedState) {
          this.movedState = pointer.x !== pointer.downX || pointer.y !== pointer.downY;
        }
        if (this.movedState) {
          this.onDrag();
        }
      }
    } else {
    }
  }
  dragCancel() {
    if (this.tracerState === TOUCH1) {
      this.onDragEnd();
    }
    this.pointer = void 0;
    this.tracerState = TOUCH0;
    return this;
  }
  onDragStart() {
    this.emit("dragstart", this);
  }
  onDragEnd() {
    this.emit("dragend", this);
  }
  onDrag() {
    this.emit("drag", this);
  }
  // onLastPointerMove() { }
  preUpdate(time, delta) {
  }
  postUpdate(time, delta) {
  }
  startTicking() {
    super.startTicking();
    this.scene.sys.events.on("preupdate", this.preUpdate, this);
    this.scene.sys.events.on("postupdate", this.postUpdate, this);
  }
  stopTicking() {
    super.stopTicking();
    if (this.scene) {
      this.scene.sys.events.off("preupdate", this.preUpdate, this);
      this.scene.sys.events.off("postupdate", this.postUpdate, this);
    }
  }
  setRecongizedStateObject(stateObject) {
    this.recongizedState = stateObject;
    return this;
  }
  get state() {
    return this.recongizedState.state;
  }
  set state(newState) {
    this.recongizedState.state = newState;
  }
  cancel() {
    this.state = IDLE;
    return this;
  }
};
var TOUCH0 = 0;
var TOUCH1 = 1;
var IDLE = "IDLE";
var OnePointerTracer_default = OnePointerTracer;

// node_modules/phaser3-rex-plugins/plugins/fsm.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/logic/fsm/FSM.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/logic/fsm/FSMBase.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/object/GetValue.js
init_shim();
var GetValue3 = function(source, key, defaultValue) {
  if (!source || typeof source === "number") {
    return defaultValue;
  } else if (source.hasOwnProperty(key)) {
    return source[key];
  } else if (key.indexOf(".") !== -1) {
    var keys = key.split(".");
    var parent = source;
    var value = defaultValue;
    for (var i = 0; i < keys.length; i++) {
      if (parent.hasOwnProperty(keys[i])) {
        value = parent[keys[i]];
        parent = parent[keys[i]];
      } else {
        value = defaultValue;
        break;
      }
    }
    return value;
  } else {
    return defaultValue;
  }
};
var GetValue_default = GetValue3;

// node_modules/phaser3-rex-plugins/plugins/logic/fsm/FSMBase.js
var StateProperties = ["next", "exit", "enter"];
var FSM = class {
  /*
  var config = {
      start: 'A',   // default: undefined
      states: {
          A: {
              next: 'B',  // function() { return 'B'; }
              enter: function() {},
              exit: function() {},
          },
          // ...
      },        
      extend: {
          i: 0,
          name: 'abc'
          // ...
      },
      init: function() {},
      enable: true,
      eventEmitter: true,
  };
  */
  constructor(config) {
    var states = GetValue_default(config, "states", void 0);
    if (states) {
      this.addStates(states);
    }
    var extend = GetValue_default(config, "extend", void 0);
    if (extend) {
      for (var name in extend) {
        if (!this.hasOwnProperty(name) || this[name] === void 0) {
          this[name] = extend[name];
        }
      }
    }
    var eventEmitter = GetValue_default(config, "eventEmitter", void 0);
    var EventEmitterClass = GetValue_default(config, "EventEmitterClass", void 0);
    this.setEventEmitter(eventEmitter, EventEmitterClass);
    this._stateLock = false;
    this.resetFromJSON(config);
  }
  shutdown() {
    this.destroyEventEmitter();
  }
  destroy() {
    this.shutdown();
  }
  resetFromJSON(o) {
    this.setEnable(GetValue_default(o, "enable", true));
    this.start(GetValue_default(o, "start", void 0));
    var init = GetValue_default(o, "init", void 0);
    if (init) {
      init.call(this);
    }
    return this;
  }
  toJSON() {
    return {
      curState: this.state,
      prevState: this.prevState,
      enable: this.enable,
      start: this._start
    };
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  set state(newState) {
    if (!this.enable || this._stateLock) {
      return;
    }
    if (this._state === newState) {
      return;
    }
    this._prevState = this._state;
    this._state = newState;
    this._stateLock = true;
    this.emit("statechange", this);
    if (this._prevState != null) {
      var exitEventName = "exit_" + this._prevState;
      var exitCallback = this[exitEventName];
      if (exitCallback) {
        exitCallback.call(this);
      }
      this.emit(exitEventName, this);
    }
    this._stateLock = false;
    if (this._state != null) {
      var enterEventName = "enter_" + this._state;
      var enterCallback = this[enterEventName];
      if (enterCallback) {
        enterCallback.call(this);
      }
      this.emit(enterEventName, this);
    }
  }
  get state() {
    return this._state;
  }
  get prevState() {
    return this._prevState;
  }
  start(state) {
    this._start = state;
    this._prevState = void 0;
    this._state = state;
    return this;
  }
  goto(nextState) {
    if (nextState != null) {
      this.state = nextState;
    }
    return this;
  }
  next() {
    var nextState;
    var getNextState = this["next_" + this.state];
    if (getNextState) {
      if (typeof getNextState === "string") {
        nextState = getNextState;
      } else {
        nextState = getNextState.call(this);
      }
    }
    this.goto(nextState);
    return this;
  }
  get stateProperties() {
    return StateProperties;
  }
  addState(name, state) {
    if (typeof name !== "string") {
      state = name;
      name = state.name;
    }
    var stateProperties = this.stateProperties;
    for (var i = 0, cnt = stateProperties.length; i < cnt; i++) {
      var propertyName = stateProperties[i];
      var propertyValue = state[propertyName];
      if (propertyValue) {
        this[`${propertyName}_${name}`] = propertyValue;
      }
    }
    return this;
  }
  addStates(states) {
    if (Array.isArray(states)) {
      for (var i = 0, cnt = states.length; i < cnt; i++) {
        this.addState(states[i]);
      }
    } else {
      for (var name in states) {
        this.addState(name, states[name]);
      }
    }
    return this;
  }
  runMethod(methodName, a1, a2, a3, a4, a5) {
    var fn = this[methodName + "_" + this.state];
    if (!fn) {
      return void 0;
    }
    var len = arguments.length;
    switch (len) {
      case 1:
        return fn.call(this);
      case 2:
        return fn.call(this, a1);
      case 3:
        return fn.call(this, a1, a2);
      case 4:
        return fn.call(this, a1, a2, a3);
      case 5:
        return fn.call(this, a1, a2, a3, a4);
      case 6:
        return fn.call(this, a1, a2, a3, a4, a5);
    }
    var args = new Array(len - 1);
    for (var i = 1; i < len; i++) {
      args[i - 1] = arguments[i];
    }
    return fn.apply(this, args);
  }
};
Object.assign(
  FSM.prototype,
  EventEmitterMethods_default
);
var FSMBase_default = FSM;

// node_modules/phaser3-rex-plugins/plugins/utils/eventemitter/HasListener.js
init_shim();
var HasListener = function(eventEmitter, eventName, fn, context, once) {
  if (once === void 0) {
    once = false;
  }
  var listeners = eventEmitter._events[eventName];
  if (!listeners) {
    return false;
  }
  for (var i = 0, cnt = listeners.length; i < cnt; i++) {
    var listener = listeners[i];
    if (listener.fn === fn && listener.context === context && listener.once === once) {
      return true;
    }
  }
  return false;
};
var HasListener_default = HasListener;

// node_modules/phaser3-rex-plugins/plugins/logic/fsm/FSM.js
var StateProperties2 = ["next", "exit", "enter", "update", "preupdate", "postupdate"];
var FSM2 = class extends FSMBase_default {
  /*
  var config = {
      start: 'A',   // default: undefined
      states: {
          A: {
              next: 'B',  // function() { return 'B'; }
              enter: function() {},
              exit: function() {},
              update: function(time, delta) {},
              preupdate: function(time, delta) {},
              postupdate: function(time, delta) {},
          },
          // ...
      },        
      extend: {
          i: 0,
          name: 'abc'
          // ...
      },
      init: function() {},
      enable: true,
      scene: undefined,
      eventEmitter: true,
  };
  */
  shutdown() {
    this.stopUpdate();
    this.stopPreUpdate();
    this.stopPostUpdate();
    this._scene = void 0;
    super.shutdown();
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this._scene = GetValue_default(o, "scene", void 0);
    return this;
  }
  get stateProperties() {
    return StateProperties2;
  }
  update(time, delta) {
    this.runMethod("update", time, delta);
  }
  preupdate(time, delta) {
    this.runMethod("preupdate", time, delta);
  }
  postupdate(time, delta) {
    this.runMethod("postupdate", time, delta);
  }
  startUpdate(scene) {
    if (!scene) {
      scene = this._scene;
    }
    var eventEmitter = scene.sys.events;
    if (HasListener_default(eventEmitter, "update", this.update, this)) {
      return this;
    }
    this._scene = scene;
    eventEmitter.on("update", this.update, this);
    return this;
  }
  stopUpdate() {
    if (!this._scene) {
      return this;
    }
    this._scene.sys.events.off("update", this.update, this);
    return this;
  }
  startPreUpdate(scene) {
    if (!scene) {
      scene = this._scene;
    }
    var eventEmitter = scene.sys.events;
    if (HasListener_default(eventEmitter, "preupdate", this.preupdate, this)) {
      return this;
    }
    this._scene = scene;
    eventEmitter.on("preupdate", this.preupdate, this);
    return this;
  }
  stopPreUpdate() {
    if (!this._scene) {
      return this;
    }
    this._scene.sys.events.off("preupdate", this.preupdate, this);
    return this;
  }
  startPostUpdate(scene) {
    if (!scene) {
      scene = this._scene;
    }
    var eventEmitter = scene.sys.events;
    if (HasListener_default(eventEmitter, "postupdate", this.postupdate, this)) {
      return this;
    }
    this._scene = scene;
    eventEmitter.on("postupdate", this.postupdate, this);
    return this;
  }
  stopPostUpdate() {
    if (!this._scene) {
      return this;
    }
    this._scene.sys.events.off("postupdate", this.postupdate, this);
    return this;
  }
};
var FSM_default = FSM2;

// node_modules/phaser3-rex-plugins/plugins/fsm.js
var fsm_default = FSM_default;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/tap/Tap.js
var GetValue4 = Phaser.Utils.Objects.GetValue;
var DistanceBetween = Phaser.Math.Distance.Between;
var Tap = class extends OnePointerTracer_default {
  constructor(gameObject, config) {
    super(gameObject, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {
          enter: function() {
            self.stop();
            self.tapsCount = 0;
            self.x = 0;
            self.y = 0;
            self.worldX = 0;
            self.worldY = 0;
          },
          exit: function() {
            var pointer = self.lastPointer;
            self.x = pointer.x;
            self.y = pointer.y;
            self.worldX = pointer.worldX;
            self.worldY = pointer.worldY;
          }
        },
        BEGIN: {
          enter: function() {
            self.start();
            self.tapsCount = 0;
            self.emit("tappingstart", self, self.gameObject, self.lastPointer);
          }
        },
        RECOGNIZED: {
          enter: function() {
            self.start();
            self.emit("tap", self, self.gameObject, self.lastPointer);
            self.emit(`${self.tapsCount}tap`, self, self.gameObject, self.lastPointer);
          }
        }
      },
      init: function() {
        this.state = IDLE2;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setHoldTime(GetValue4(o, "time", 250));
    this.setTapInterval(GetValue4(o, "tapInterval", 200));
    this.setDragThreshold(GetValue4(o, "threshold", 9));
    this.setTapOffset(GetValue4(o, "tapOffset", 10));
    var taps = GetValue4(o, "taps", void 0);
    if (taps !== void 0) {
      this.setTaps(taps);
    } else {
      this.setMaxTaps(GetValue4(o, "maxTaps", void 0));
      this.setMinTaps(GetValue4(o, "minTaps", void 0));
    }
    return this;
  }
  onDragStart() {
    switch (this.state) {
      case IDLE2:
        this.state = BEGIN;
        break;
      case BEGIN:
        var pointer = this.lastPointer;
        var tapsOffset = DistanceBetween(
          pointer.upX,
          pointer.upY,
          pointer.x,
          pointer.y
        );
        if (tapsOffset > this.tapOffset) {
          this.state = RECOGNIZED;
          this.state = BEGIN;
        }
        break;
      case RECOGNIZED:
        this.state = BEGIN;
        break;
    }
  }
  onDragEnd() {
    if (this.state === BEGIN) {
      this.tapsCount++;
      this.emit("tapping", this, this.gameObject, this.lastPointer);
      if (this.maxTaps !== void 0 && this.tapsCount === this.maxTaps) {
        this.state = RECOGNIZED;
      }
    }
  }
  onDrag() {
    if (this.state === IDLE2) {
      return;
    }
    if (this.pointer.getDistance() > this.dragThreshold) {
      this.state = IDLE2;
    }
  }
  preUpdate(time, delta) {
    if (!this.isRunning || !this.enable) {
      return;
    }
    if (this.state === BEGIN) {
      var pointer = this.lastPointer;
      if (pointer.isDown) {
        var holdTime = time - pointer.downTime;
        if (holdTime > this.holdTime) {
          this.state = IDLE2;
        }
      } else {
        var releasedTime = time - pointer.upTime;
        if (releasedTime > this.tapInterval) {
          if (this.minTaps === void 0 || this.tapsCount >= this.minTaps) {
            this.state = RECOGNIZED;
          } else {
            this.state = IDLE2;
          }
        }
      }
    }
  }
  postUpdate(time, delta) {
    if (!this.isRunning || !this.enable) {
      return;
    }
    if (this.state === RECOGNIZED) {
      this.state = IDLE2;
    }
  }
  get isTapped() {
    return this.state === RECOGNIZED;
  }
  setHoldTime(time) {
    this.holdTime = time;
    return this;
  }
  setTapInterval(time) {
    this.tapInterval = time;
    return this;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
  setTapOffset(distance) {
    this.tapOffset = distance;
    return this;
  }
  setMaxTaps(taps) {
    this.maxTaps = taps;
    return this;
  }
  setMinTaps(taps) {
    this.minTaps = taps;
    return this;
  }
  setTaps(minTaps, maxTaps) {
    if (maxTaps === void 0) {
      maxTaps = minTaps;
    }
    this.setMinTaps(minTaps).setMaxTaps(maxTaps);
    return this;
  }
};
var IDLE2 = "IDLE";
var BEGIN = "BEGIN";
var RECOGNIZED = "RECOGNIZED";
var Tap_default = Tap;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/press/Press.js
init_shim();
var GetValue5 = Phaser.Utils.Objects.GetValue;
var Press = class extends OnePointerTracer_default {
  constructor(gameObject, config) {
    super(gameObject, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {
          enter: function() {
            self.x = 0;
            self.y = 0;
            self.worldX = 0;
            self.worldY = 0;
          },
          exit: function() {
            var pointer = self.lastPointer;
            self.x = pointer.x;
            self.y = pointer.y;
            self.worldX = pointer.worldX;
            self.worldY = pointer.worldY;
          }
        },
        BEGIN: {
          enter: function() {
            self.start();
          },
          exit: function() {
            self.stop();
          }
        },
        RECOGNIZED: {
          enter: function() {
            self.emit("pressstart", self, self.gameObject, self.lastPointer);
          },
          exit: function() {
            self.emit("pressend", self, self.gameObject, self.lastPointer);
          }
        }
      },
      init: function() {
        this.state = IDLE3;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setDragThreshold(GetValue5(o, "threshold", 9));
    this.setHoldTime(GetValue5(o, "time", 251));
    return this;
  }
  onDragStart() {
    this.state = BEGIN2;
    if (this.holdTime === 0) {
      this.state = RECOGNIZED2;
    }
  }
  onDragEnd() {
    this.state = IDLE3;
  }
  onDrag() {
    if (this.state === IDLE3) {
      return;
    }
    if (this.pointer.getDistance() > this.dragThreshold) {
      this.state = IDLE3;
    }
  }
  preUpdate(time, delta) {
    if (!this.isRunning || !this.enable) {
      return;
    }
    if (this.state === BEGIN2) {
      var holdTime = time - this.pointer.downTime;
      if (holdTime >= this.holdTime) {
        this.state = RECOGNIZED2;
      }
    }
  }
  get isPressed() {
    return this.state === RECOGNIZED2;
  }
  setHoldTime(time) {
    this.holdTime = time;
    return this;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
};
var IDLE3 = "IDLE";
var BEGIN2 = "BEGIN";
var RECOGNIZED2 = "RECOGNIZED";
var Press_default = Press;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/pan/Pan.js
init_shim();
var GetValue6 = Phaser.Utils.Objects.GetValue;
var Pan = class extends OnePointerTracer_default {
  constructor(gameObject, config) {
    super(gameObject, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {},
        BEGIN: {
          enter: function() {
            var pointer = self.pointer;
            self.startX = pointer.x;
            self.startY = pointer.y;
            self.startWorldX = pointer.worldX;
            self.startWorldY = pointer.worldY;
          }
        },
        RECOGNIZED: {
          enter: function() {
            self.emit("panstart", self, self.gameObject, self.lastPointer);
          },
          exit: function() {
            var pointer = self.lastPointer;
            self.endX = pointer.x;
            self.endY = pointer.y;
            self.endWorldX = pointer.worldX;
            self.endWorldY = pointer.worldY;
            self.emit("panend", self, self.gameObject, self.lastPointer);
          }
        }
      },
      init: function() {
        this.state = IDLE4;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setDragThreshold(GetValue6(o, "threshold", 10));
    return this;
  }
  onDragStart() {
    this.state = BEGIN3;
    if (this.dragThreshold === 0) {
      this.state = RECOGNIZED3;
    }
  }
  onDragEnd() {
    this.state = IDLE4;
  }
  onDrag() {
    switch (this.state) {
      case BEGIN3:
        if (this.pointer.getDistance() >= this.dragThreshold) {
          this.state = RECOGNIZED3;
        }
        break;
      case RECOGNIZED3:
        var p1 = this.pointer.position;
        var p0 = this.pointer.prevPosition;
        this.dx = p1.x - p0.x;
        this.dy = p1.y - p0.y;
        var pointer = this.pointer;
        this.x = pointer.x;
        this.y = pointer.y;
        this.worldX = pointer.worldX;
        this.worldY = pointer.worldY;
        this.emit("pan", this, this.gameObject, this.lastPointer);
        break;
    }
  }
  get isPanned() {
    return this.state === RECOGNIZED3;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
};
var IDLE4 = "IDLE";
var BEGIN3 = "BEGIN";
var RECOGNIZED3 = "RECOGNIZED";
var Pan_default = Pan;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/swipe/Swipe.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/gestures/swipe/VelocityMethods.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/system/GetTickDelta.js
init_shim();
var GetTickDelta = function(game) {
  return GetGame_default(game).loop.delta;
};
var GetTickDelta_default = GetTickDelta;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/swipe/VelocityMethods.js
var DistanceBetween2 = Phaser.Math.Distance.Between;
var AngleBetween = Phaser.Math.Angle.Between;
var VelocityMethods_default = {
  getDt: function() {
    var dt = GetTickDelta_default(this.scene);
    return dt;
  },
  getVelocity: function() {
    var p1 = this.pointer.position;
    var p0 = this.pointer.prevPosition;
    var d = DistanceBetween2(p0.x, p0.y, p1.x, p1.y);
    var velocity = d / (this.getDt() * 1e-3);
    return velocity;
  },
  getVelocityX: function() {
    var p1 = this.pointer.position;
    var p0 = this.pointer.prevPosition;
    var d = Math.abs(p1.x - p0.x);
    var velocity = d / (this.getDt() * 1e-3);
    return velocity;
  },
  getVelocityY: function() {
    var p1 = this.pointer.position;
    var p0 = this.pointer.prevPosition;
    var d = Math.abs(p1.y - p0.y);
    var velocity = d / (this.getDt() * 1e-3);
    return velocity;
  },
  getVelocityAngle: function() {
    var p1 = this.pointer.position;
    var p0 = this.pointer.prevPosition;
    var angle = AngleBetween(p0.x, p0.y, p1.x, p1.y);
    return angle;
  }
};

// node_modules/phaser3-rex-plugins/plugins/input/gestures/swipe/Swipe.js
var GetValue7 = Phaser.Utils.Objects.GetValue;
var RadToDeg = Phaser.Math.RadToDeg;
var Swipe = class extends OnePointerTracer_default {
  constructor(gameObject, config) {
    super(gameObject, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {
          enter: function() {
            self.x = 0;
            self.y = 0;
            self.worldX = 0;
            self.worldY = 0;
          },
          exit: function() {
            var pointer = self.lastPointer;
            self.x = pointer.x;
            self.y = pointer.y;
            self.worldX = pointer.worldX;
            self.worldY = pointer.worldY;
          }
        },
        BEGIN: {
          enter: function() {
            self.validDrag = false;
          }
        },
        RECOGNIZED: {
          enter: function() {
            self.start();
            self.updateDirectionStates();
            self.emit("swipe", self, self.gameObject, self.lastPointer);
          },
          exit: function() {
            self.stop();
            self.clearDirectionStates();
          }
        }
      },
      init: function() {
        this.state = IDLE5;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
    this.clearDirectionStates();
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setDragThreshold(GetValue7(o, "threshold", 10));
    this.setVelocityThreshold(GetValue7(o, "velocityThreshold", 1e3));
    this.setDirectionMode(GetValue7(o, "dir", "8dir"));
    return this;
  }
  onDragStart() {
    this.state = BEGIN4;
  }
  onDragEnd() {
    this.state = IDLE5;
  }
  onDrag() {
    if (this.state === BEGIN4) {
      if (!this.validDrag) {
        this.validDrag = this.dragThreshold === 0 || this.pointer.getDistance() >= this.dragThreshold;
      }
      if (this.validDrag && this.dragVelocity > this.velocityThreshold) {
        this.state = RECOGNIZED4;
      }
    }
  }
  postUpdate(time, delta) {
    if (!this.isRunning || !this.enable) {
      return;
    }
    if (this.state === RECOGNIZED4) {
      this.state = IDLE5;
    }
  }
  get isSwiped() {
    return this.state === RECOGNIZED4;
  }
  get dragVelocity() {
    var velocity;
    switch (this.dirMode) {
      case 0:
        velocity = this.getVelocityY();
        break;
      case 1:
        velocity = this.getVelocityX();
        break;
      default:
        velocity = this.getVelocity();
        break;
    }
    return velocity;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
  setVelocityThreshold(velocity) {
    this.velocityThreshold = velocity;
    return this;
  }
  setDirectionMode(m) {
    if (typeof m === "string") {
      m = Const_default[m];
    }
    this.dirMode = m;
    return this;
  }
  updateDirectionStates() {
    var angle = RadToDeg(this.getVelocityAngle());
    AngleToDirections_default(angle, this.dirMode, this);
    return this;
  }
  clearDirectionStates() {
    this.left = false;
    this.right = false;
    this.up = false;
    this.down = false;
    return this;
  }
};
Object.assign(
  Swipe.prototype,
  VelocityMethods_default
);
var IDLE5 = "IDLE";
var BEGIN4 = "BEGIN";
var RECOGNIZED4 = "RECOGNIZED";
var Swipe_default = Swipe;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/pinch/Pinch.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/gestures/twopointerstracer/TwoPointersTracer.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/object/Clear.js
init_shim();
var Clear = function(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    obj.length = 0;
  } else {
    for (var key in obj) {
      delete obj[key];
    }
  }
  return obj;
};
var Clear_default = Clear;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/twopointerstracer/TwoPointersTracer.js
var GetValue8 = Phaser.Utils.Objects.GetValue;
var SpliceOne = Phaser.Utils.Array.SpliceOne;
var DistanceBetween3 = Phaser.Math.Distance.Between;
var AngleBetween2 = Phaser.Math.Angle.Between;
var TwoPointersTracer = class {
  constructor(scene, config) {
    var amount = scene.input.manager.pointersTotal - 1;
    if (amount < 2) {
      scene.input.addPointer(2 - amount);
    }
    this.scene = scene;
    this.setEventEmitter(GetValue8(config, "eventEmitter", void 0));
    this._enable = void 0;
    this.pointers = [];
    this.movedState = {};
    this.resetFromJSON(config);
    this.boot();
  }
  resetFromJSON(o) {
    this.setEnable(GetValue8(o, "enable", true));
    this.bounds = GetValue8(o, "bounds", void 0);
    this.tracerState = TOUCH02;
    this.pointers.length = 0;
    Clear_default(this.movedState);
    return this;
  }
  boot() {
    this.scene.input.on("pointerdown", this.onPointerDown, this);
    this.scene.input.on("pointerup", this.onPointerUp, this);
    this.scene.input.on("gameout", this.dragCancel, this);
    this.scene.input.on("pointermove", this.onPointerMove, this);
    this.scene.sys.events.once("shutdown", this.destroy, this);
  }
  shutdown() {
    if (!this.scene) {
      return;
    }
    this.destroyEventEmitter();
    this.pointers.length = 0;
    Clear_default(this.movedState);
    this.scene.input.off("pointerdown", this.onPointerDown, this);
    this.scene.input.off("pointerup", this.onPointerUp, this);
    this.scene.input.off("gameout", this.dragCancel, this);
    this.scene.input.off("pointermove", this.onPointerMove, this);
    this.scene.sys.events.off("shutdown", this.destroy, this);
    this.scene = void 0;
  }
  destroy() {
    this.shutdown();
  }
  get enable() {
    return this._enable;
  }
  set enable(e) {
    if (this._enable === e) {
      return;
    }
    if (!e) {
      this.dragCancel();
    }
    this._enable = e;
    return this;
  }
  setEnable(e) {
    if (e === void 0) {
      e = true;
    }
    this.enable = e;
    return this;
  }
  toggleEnable() {
    this.setEnable(!this.enable);
    return this;
  }
  onPointerDown(pointer) {
    if (!this.enable) {
      return;
    }
    if (this.pointers.length === 2) {
      return;
    }
    var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
    if (!isInsideBounds) {
      return;
    }
    var index = this.pointers.indexOf(pointer);
    if (index !== -1) {
      return;
    }
    this.movedState[pointer.id] = false;
    this.pointers.push(pointer);
    switch (this.tracerState) {
      case TOUCH02:
        this.tracerState = TOUCH12;
        this.onDrag1Start();
        break;
      case TOUCH12:
        this.tracerState = TOUCH2;
        this.onDrag2Start();
        break;
    }
  }
  onPointerUp(pointer) {
    if (!this.enable) {
      return;
    }
    var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
    if (!isInsideBounds) {
      return;
    }
    var index = this.pointers.indexOf(pointer);
    if (index === -1) {
      return;
    } else {
      delete this.movedState[pointer.id];
      SpliceOne(this.pointers, index);
    }
    switch (this.tracerState) {
      case TOUCH12:
        this.tracerState = TOUCH02;
        this.onDrag1End();
        break;
      case TOUCH2:
        this.tracerState = TOUCH12;
        this.onDrag2End();
        this.onDrag1Start();
        break;
    }
  }
  onPointerMove(pointer) {
    if (!this.enable) {
      return;
    }
    if (pointer.isDown) {
      var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
      var isCatchedPointer = this.pointers.indexOf(pointer) !== -1;
      if (!isCatchedPointer && isInsideBounds) {
      } else if (isCatchedPointer && !isInsideBounds) {
        this.onPointerUp(pointer);
      } else {
        if (!this.movedState[pointer.id]) {
          this.movedState[pointer.id] = pointer.x !== pointer.downX || pointer.y !== pointer.downY;
        }
        if (this.movedState[pointer.id]) {
          switch (this.tracerState) {
            case TOUCH12:
              this.onDrag1();
              break;
            case TOUCH2:
              this.onDrag2();
              break;
          }
        }
      }
    }
  }
  dragCancel() {
    if (this.tracerState === TOUCH2) {
      this.onDrag2End();
    }
    this.pointers.length = 0;
    Clear_default(this.movedState);
    this.tracerState = TOUCH02;
    return this;
  }
  onDrag1Start() {
    this.emit("drag1start", this);
  }
  onDrag1End() {
    this.emit("drag1end", this);
  }
  onDrag1() {
    this.emit("drag1", this);
  }
  onDrag2Start() {
    this.emit("drag2start", this);
  }
  onDrag2End() {
    this.emit("drag2end", this);
  }
  onDrag2() {
    this.emit("drag2", this);
  }
  get distanceBetween() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var p0 = this.pointers[0], p1 = this.pointers[1];
    return DistanceBetween3(p0.x, p0.y, p1.x, p1.y);
  }
  get angleBetween() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var p0 = this.pointers[0], p1 = this.pointers[1];
    return AngleBetween2(p0.x, p0.y, p1.x, p1.y);
  }
  get drag1Vector() {
    var pointer = this.pointers[0];
    if (pointer && this.movedState[pointer.id]) {
      var p1 = pointer.position;
      var p0 = pointer.prevPosition;
      tmpDragVector.x = p1.x - p0.x;
      tmpDragVector.y = p1.y - p0.y;
    } else {
      tmpDragVector.x = 0;
      tmpDragVector.y = 0;
    }
    return tmpDragVector;
  }
  get centerX() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var p0 = this.pointers[0].position;
    var p1 = this.pointers[1].position;
    return (p0.x + p1.x) / 2;
  }
  get centerY() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var p0 = this.pointers[0].position;
    var p1 = this.pointers[1].position;
    return (p0.y + p1.y) / 2;
  }
  get prevCenterX() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var preP0 = this.movedState[this.pointers[0].id] ? this.pointers[0].prevPosition : this.pointers[0].position;
    var preP1 = this.movedState[this.pointers[1].id] ? this.pointers[1].prevPosition : this.pointers[1].position;
    return (preP0.x + preP1.x) / 2;
  }
  get prevCenterY() {
    if (this.tracerState !== TOUCH2) {
      return 0;
    }
    var preP0 = this.movedState[this.pointers[0].id] ? this.pointers[0].prevPosition : this.pointers[0].position;
    var preP1 = this.movedState[this.pointers[1].id] ? this.pointers[1].prevPosition : this.pointers[1].position;
    return (preP0.y + preP1.y) / 2;
  }
  get movementCenterX() {
    return this.centerX - this.prevCenterX;
  }
  get movementCenterY() {
    return this.centerY - this.prevCenterY;
  }
  setRecongizedStateObject(stateObject) {
    this.recongizedState = stateObject;
    return this;
  }
  get state() {
    return this.recongizedState.state;
  }
  set state(newState) {
    this.recongizedState.state = newState;
  }
  cancel() {
    this.state = IDLE6;
    return this;
  }
};
Object.assign(
  TwoPointersTracer.prototype,
  EventEmitterMethods_default
);
var tmpDragVector = {};
var TOUCH02 = 0;
var TOUCH12 = 1;
var TOUCH2 = 2;
var IDLE6 = "IDLE";
var TwoPointersTracer_default = TwoPointersTracer;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/pinch/Pinch.js
var GetValue9 = Phaser.Utils.Objects.GetValue;
var Pinch = class extends TwoPointersTracer_default {
  constructor(scene, config) {
    super(scene, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {
          enter: function() {
            self.prevDistance = void 0;
            self.scaleFactor = 1;
          }
        },
        BEGIN: {},
        RECOGNIZED: {
          enter: function() {
            self.emit("pinchstart", self);
          },
          exit: function() {
            self.emit("pinchend", self);
          }
        }
      },
      init: function() {
        this.state = IDLE7;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setDragThreshold(GetValue9(o, "threshold", 0));
    return this;
  }
  onDrag2Start() {
    this.scaleFactor = 1;
    this.prevDistance = this.distanceBetween;
    this.state = BEGIN5;
    if (this.dragThreshold === 0) {
      this.state = RECOGNIZED5;
    }
  }
  onDrag2End() {
    this.state = IDLE7;
  }
  onDrag2() {
    switch (this.state) {
      case BEGIN5:
        if (this.pointers[0].getDistance() >= this.dragThreshold && this.pointers[1].getDistance() >= this.dragThreshold) {
          var curDistance = this.distanceBetween;
          this.scaleFactor = curDistance / this.prevDistance;
          this.prevDistance = curDistance;
          this.state = RECOGNIZED5;
        }
        break;
      case RECOGNIZED5:
        var curDistance = this.distanceBetween;
        this.scaleFactor = curDistance / this.prevDistance;
        this.emit("pinch", this);
        this.prevDistance = curDistance;
        break;
    }
  }
  get isPinched() {
    return this.state === RECOGNIZED5;
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
};
var IDLE7 = "IDLE";
var BEGIN5 = "BEGIN";
var RECOGNIZED5 = "RECOGNIZED";
var Pinch_default = Pinch;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/rotate/Rotate.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/input/gestures/rotate/SpinObject.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/actions/RotateObjectAround.js
init_shim();
var RotateAround = Phaser.Math.RotateAround;
var RotateObjectAround = function(gameObject, x, y, angle) {
  RotateAround(gameObject, x, y, angle);
  gameObject.rotation += angle;
  return gameObject;
};
var RotateObjectAround_default = RotateObjectAround;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/rotate/SpinObject.js
var SpinObject = function(gameObject, camera) {
  if (!this.isRotation) {
    return this;
  }
  if (camera === void 0) {
    camera = this.pointers[0].camera;
  }
  var movementX = this.movementCenterX, movementY = this.movementCenterY;
  var worldXY = ScreenXYToWorldXY_default(this.centerX, this.centerY, camera, true);
  var centerWorldX = worldXY.x;
  var centerWorldY = worldXY.y;
  var angle = this.rotation;
  if (Array.isArray(gameObject)) {
    var gameObjects = gameObject;
    for (var i = 0, cnt = gameObjects.length; i < cnt; i++) {
      gameObject = gameObjects[i];
      gameObject.x += movementX;
      gameObject.y += movementY;
      RotateObjectAround_default(gameObject, centerWorldX, centerWorldY, angle);
    }
  } else {
    gameObject.x += movementX;
    gameObject.y += movementY;
    RotateObjectAround_default(gameObject, centerWorldX, centerWorldY, angle);
  }
  return this;
};
var SpinObject_default = SpinObject;

// node_modules/phaser3-rex-plugins/plugins/input/gestures/rotate/Rotate.js
var GetValue10 = Phaser.Utils.Objects.GetValue;
var WrapDegrees = Phaser.Math.Angle.WrapDegrees;
var ShortestBetween = Phaser.Math.Angle.ShortestBetween;
var RadToDeg2 = Phaser.Math.RadToDeg;
var DegToRad = Phaser.Math.DegToRad;
var Rotate = class extends TwoPointersTracer_default {
  constructor(scene, config) {
    super(scene, config);
    var self = this;
    var stateConfig = {
      states: {
        IDLE: {
          enter: function() {
            self.prevAngle = void 0;
            self.angle = 0;
          }
        },
        BEGIN: {},
        RECOGNIZED: {
          enter: function() {
            self.emit("rotatestart", self);
          },
          exit: function() {
            self.emit("rotateend", self);
          }
        }
      },
      init: function() {
        this.state = IDLE8;
      },
      eventEmitter: false
    };
    this.setRecongizedStateObject(new fsm_default(stateConfig));
  }
  resetFromJSON(o) {
    super.resetFromJSON(o);
    this.setDragThreshold(GetValue10(o, "threshold", 0));
    return this;
  }
  onDrag2Start() {
    this.prevAngle = WrapDegrees(RadToDeg2(this.angleBetween));
    this.state = BEGIN6;
    if (this.dragThreshold === 0) {
      this.state = RECOGNIZED6;
    }
  }
  onDrag2End() {
    this.state = IDLE8;
  }
  onDrag2() {
    switch (this.state) {
      case BEGIN6:
        if (this.pointers[0].getDistance() >= this.dragThreshold && this.pointers[1].getDistance() >= this.dragThreshold) {
          var curAngle = WrapDegrees(RadToDeg2(this.angleBetween));
          this.angle = ShortestBetween(this.prevAngle, curAngle);
          this.prevAngle = curAngle;
          this.state = RECOGNIZED6;
        }
        break;
      case RECOGNIZED6:
        var curAngle = WrapDegrees(RadToDeg2(this.angleBetween));
        this.angle = ShortestBetween(this.prevAngle, curAngle);
        this.prevAngle = curAngle;
        this.emit("rotate", this);
        break;
    }
  }
  get isRotated() {
    return this.state === RECOGNIZED6;
  }
  get rotation() {
    return DegToRad(this.angle);
  }
  setDragThreshold(distance) {
    this.dragThreshold = distance;
    return this;
  }
};
var methods = {
  spinObject: SpinObject_default
};
Object.assign(
  Rotate.prototype,
  methods
);
var IDLE8 = "IDLE";
var BEGIN6 = "BEGIN";
var RECOGNIZED6 = "RECOGNIZED";
var Rotate_default = Rotate;
export {
  Pan_default as Pan,
  Pinch_default as Pinch,
  Press_default as Press,
  Rotate_default as Rotate,
  Swipe_default as Swipe,
  Tap_default as Tap
};
